// @ts-nocheck
import { Component } from 'react';
import { ApplyPluginsType } from 'umi';
import dva from 'dva';
// @ts-ignore
import createLoading from '/Users/sunzhao/Desktop/Work/Xian/xi_fleet/node_modules/dva-loading/dist/index.esm.js';
import { plugin, history } from '../core/umiExports';
import ModelGlobal0 from '/Users/sunzhao/Desktop/Work/Xian/xi_fleet/src/models/global.js';
import ModelLogin1 from '/Users/sunzhao/Desktop/Work/Xian/xi_fleet/src/models/login.js';
import ModelModel2 from '/Users/sunzhao/Desktop/Work/Xian/xi_fleet/src/pages/basicInfo/myInfo/model.js';
import ModelModel3 from '/Users/sunzhao/Desktop/Work/Xian/xi_fleet/src/pages/basicSetting/administrator/model.js';
import ModelModel4 from '/Users/sunzhao/Desktop/Work/Xian/xi_fleet/src/pages/financial/changeRecord/model.js';
import ModelModel5 from '/Users/sunzhao/Desktop/Work/Xian/xi_fleet/src/pages/financial/chargingBill/model.js';
import ModelModel6 from '/Users/sunzhao/Desktop/Work/Xian/xi_fleet/src/pages/financial/driverAccount/model.js';
import ModelModel7 from '/Users/sunzhao/Desktop/Work/Xian/xi_fleet/src/pages/financial/invoiceApply/model.js';
import ModelModel8 from '/Users/sunzhao/Desktop/Work/Xian/xi_fleet/src/pages/fleet/carInfo/model.js';
import ModelModel9 from '/Users/sunzhao/Desktop/Work/Xian/xi_fleet/src/pages/fleet/electricCard/model.js';
import ModelModel10 from '/Users/sunzhao/Desktop/Work/Xian/xi_fleet/src/pages/home/model.js';
import ModelModel11 from '/Users/sunzhao/Desktop/Work/Xian/xi_fleet/src/pages/order/seize/model.js';

let app:any = null;

export function _onCreate(options = {}) {
  const runtimeDva = plugin.applyPlugins({
    key: 'dva',
    type: ApplyPluginsType.modify,
    initialValue: {},
  });
  app = dva({
    history,
    
    ...(runtimeDva.config || {}),
    // @ts-ignore
    ...(typeof window !== 'undefined' && window.g_useSSR ? { initialState: window.g_initialProps } : {}),
    ...(options || {}),
  });
  
  app.use(createLoading());
  (runtimeDva.plugins || []).forEach((plugin:any) => {
    app.use(plugin);
  });
  app.model({ namespace: 'global', ...ModelGlobal0 });
app.model({ namespace: 'login', ...ModelLogin1 });
app.model({ namespace: 'model', ...ModelModel2 });
app.model({ namespace: 'model', ...ModelModel3 });
app.model({ namespace: 'model', ...ModelModel4 });
app.model({ namespace: 'model', ...ModelModel5 });
app.model({ namespace: 'model', ...ModelModel6 });
app.model({ namespace: 'model', ...ModelModel7 });
app.model({ namespace: 'model', ...ModelModel8 });
app.model({ namespace: 'model', ...ModelModel9 });
app.model({ namespace: 'model', ...ModelModel10 });
app.model({ namespace: 'model', ...ModelModel11 });
  return app;
}

export function getApp() {
  return app;
}

/**
 * whether browser env
 * 
 * @returns boolean
 */
function isBrowser(): boolean {
  return typeof window !== 'undefined' &&
  typeof window.document !== 'undefined' &&
  typeof window.document.createElement !== 'undefined'
}

export class _DvaContainer extends Component {
  constructor(props: any) {
    super(props);
    // run only in client, avoid override server _onCreate()
    if (isBrowser()) {
      _onCreate()
    }
  }

  componentWillUnmount() {
    let app = getApp();
    app._models.forEach((model:any) => {
      app.unmodel(model.namespace);
    });
    app._models = [];
    try {
      // 释放 app，for gc
      // immer 场景 app 是 read-only 的，这里 try catch 一下
      app = null;
    } catch(e) {
      console.error(e);
    }
  }

  render() {
    let app = getApp();
    app.router(() => this.props.children);
    return app.start()();
  }
}
